'use client';

import { cn } from '@/lib/utils';
import { CheckIcon } from '@heroicons/react/24/solid';

export default function Progress({
  steps,
  currentStep,
  className,
}) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      {steps.map((step, idx) => (
        <div key={step.id} className="flex items-center flex-1">
          {/* Step Circle */}
          <div className={cn(
            'w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-all',
            currentStep > step.id
              ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30'
              : currentStep === step.id
              ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30'
              : 'bg-slate-100 text-slate-400'
          )}>
            {currentStep > step.id ? (
              <CheckIcon className="w-4 h-4" />
            ) : (
              step.id
            )}
          </div>

          {/* Connector Line */}
          {idx < steps.length - 1 && (
            <div className={cn(
              'flex-1 h-0.5 mx-2 transition-colors',
              currentStep > step.id ? 'bg-blue-500' : 'bg-slate-200'
            )} />
          )}
        </div>
      ))}
    </div>
  );
}

export function ProgressLabels({ steps, currentStep, className }) {
  return (
    <div className={cn('flex justify-between mt-2', className)}>
      {steps.map((step) => (
        <div key={step.id} className="flex-1 text-center">
          <span className={cn(
            'text-xs',
            currentStep >= step.id ? 'text-blue-600 font-medium' : 'text-slate-400'
          )}>
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
}
